import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// antd
import { theme, Typography } from 'antd'

// slices
import { profileState, switchVideoPlayModal } from '../profile.slice'

// assets
import { VideosIcon } from '../../../assets/icons'

// styles
import tabStyles from '../profileTabContent.module.css'

function VideosSummaryContent({ contentData }) {
    const { Title, Text } = Typography

    const { useToken } = theme
    const { token } = useToken()

    const dispatch = useDispatch()

    const videoEl = useRef(null)

    const { introductionVideoModal } = useSelector(profileState)

    return (
        <div className={tabStyles.summaryGrid}>
            {contentData.map((videosData, index) => {
                const startDate = new Date(videosData?.updatedAt)

                return (
                    <div
                        className={tabStyles.mediaCard}
                        key={videosData?._id || videosData?.type || index}
                    >
                        <div className={tabStyles.videoWrap}>
                            <video
                                src={videosData?.link}
                                className={tabStyles.mediaThumb}
                                ref={videoEl}
                                onLoadedMetadata={() => {
                                    const video = videoEl.current
                                    if (!video) return
                                }}
                                preview={false}
                                id={videosData?.type}
                            />
                            <div
                                className={tabStyles.playOverlay}
                                onClick={() => {
                                    dispatch(
                                        switchVideoPlayModal({
                                            ...introductionVideoModal,
                                            open: true,
                                            videoData: {
                                                deleteId: '',
                                                link: videosData?.link,
                                            },
                                            title: videosData?.type,
                                        })
                                    )
                                }}
                            >
                                <VideosIcon
                                    color={token.colorPalette.textColor.quinary}
                                />
                            </div>
                        </div>
                        <div className={tabStyles.mediaBody}>
                            <Title
                                className={`${tabStyles.mediaTitle} titleSub`}
                            >
                                {videosData?.type || 'N/A'}
                            </Title>
                            <Text>{videosData?.category || 'N/A'}</Text>
                            <Text
                                style={{
                                    fontSize: token.fontSizeLG,
                                }}
                                className={'titleLight'}
                            >
                                {startDate.toLocaleString('default', {
                                    year: 'numeric',
                                    month: 'long',
                                })}
                            </Text>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default VideosSummaryContent
